import Milestones from '../sections/milestones/milestones';

export default function MilestonesPage() {
  return (
    <div className="section-page">
      <Milestones />
    </div>
  );
}
